import { initSentry } from "./sentry";
initSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import { AppProviders } from "./providers";
import { Router } from "./router";
import "./styles/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppProviders>
      <Router />
    </AppProviders>
  </React.StrictMode>,
);
